// Core
import React from "react";

function Question(props) {
   const { answer, note, links } = props.aObj;

   return (
      <>
         <h4 class="text-primary" dangerouslySetInnerHTML={{ __html: answer }}></h4>
         <p dangerouslySetInnerHTML={{ __html: note }}></p>
         {links && (
            <div className="py-3" style={{ borderTop: "1px dashed var(--bs-gray-300)" }}>
               <p dangerouslySetInnerHTML={{ __html: links }} className="mb-0"></p>
            </div>
         )}
      </>
   );
}

export default Question;
